// Pre-launch switch. Netlify variable: VITE_PRELAUNCH_MODE (set by Normand),
// mapped to REACT_APP_PRELAUNCH_MODE at build time by
// scripts/cra-build-with-prelaunch.js — CRA only inlines REACT_APP_* vars.
//
// OFF (default, and staging): behaviour exactly as before — trial CTAs link to
// /configure and /configure is the signup wizard.
// ON: every trial CTA on the landing pages scrolls to the waitlist form, and
// /configure renders the waitlist form instead of the wizard.
//
// Build-time constant: flipping it needs a redeploy.

const raw = (process.env.REACT_APP_PRELAUNCH_MODE ?? '').trim().toLowerCase();

export const PRELAUNCH_MODE: boolean = ['true', '1', 'on', 'yes'].includes(raw);

/** Target for every trial call-to-action on the landing pages. */
export const TRIAL_HREF: string = PRELAUNCH_MODE ? '#waitlist' : '/configure';
